import Button from './Button'
export default Button


// WEBPACK FOOTER //
// ./src/modules/Button/index.js